export default "__VITE_ASSET__40ff5498__"